import AnimationModal from '../../components/animation-modal';

export default class TopBar {
  constructor (attachPoint, buttons) {
    this.attachPoint = attachPoint;

    this.modals = {
      animationModal: new AnimationModal(buttons.animationModal)
    };
  }

  initModals () {
    Object.values(this.modals).forEach(modal => {
      this.attachModal(modal);
      modal.init();
    });
  }

  attachModal (modal) {
    const notAttached = !this.attachPoint.querySelector(modal.selector);
    if (notAttached) this.attachPoint.append(modal.component);
  }
}
